// Cofactors preserve the inverse-transpose direction without dividing by a tiny determinant, including rank-two planes.
export const HS_NORMAL_TRANSFORM_SHADER_CODE: string = `
vec3 transformSurfaceNormal(mat3 linear, vec3 normal) {
  vec3 maximum = max(abs(linear[0]), max(abs(linear[1]), abs(linear[2])));
  float scale = max(maximum.x, max(maximum.y, maximum.z));
  if (scale == 0.0) return vec3(0.0);
  linear /= scale;
  mat3 cofactor = mat3(cross(linear[1], linear[2]),
    cross(linear[2], linear[0]), cross(linear[0], linear[1]));
  vec3 transformed = cofactor * normal;
  if (dot(linear[0], cofactor[0]) < 0.0) transformed = -transformed;
  float magnitude = length(transformed);
  return magnitude > 0.0 ? transformed / magnitude : vec3(0.0);
}`;
